module.exports = {
      id: "movie-icon-usage",
      viewBox: "0 0 16 19",
      url: __webpack_public_path__ + "svg-sprite.svg#movie-icon",
      toString: function () {
        return this.url;
      }
    }